import { render, staticRenderFns } from "./flashSale.vue?vue&type=template&id=19a9f59d&scoped=true&"
import script from "./flashSale.vue?vue&type=script&lang=js&"
export * from "./flashSale.vue?vue&type=script&lang=js&"
import style0 from "./flashSale.vue?vue&type=style&index=0&id=19a9f59d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a9f59d",
  null
  
)

export default component.exports